var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrowActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-settings-collapse",
    transform: "translate(-694.000000, -717.000000)",
    fill: "#FF6F47",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.746556,721.128903 C692.127383,720.578527 691.179276,720.634298 690.6289,721.253471 C690.078524,721.872644 690.134295,722.820751 690.753468,723.371127 L697.503456,729.371116 C698.071784,729.876296 698.928216,729.876296 699.496544,729.371116 L706.246532,723.371127 C706.865705,722.820751 706.921476,721.872644 706.3711,721.253471 C705.820724,720.634298 704.872617,720.578527 704.253444,721.128903 L698.5,726.243075 L692.746556,721.128903 Z",
    id: "Path-4",
    transform: "translate(698.500000, 725.250001) scale(-1, 1) rotate(-90.000000) translate(-698.500000, -725.250001) "
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftArrowActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leftArrow_active.af9ef52bde486103b9063ee2bacd1ea7.svg";